<template>
  <div class="d-flex flex-column">
    <apexchart
      ref="chart"
      width="100%"
      height="100%"
      :options="options"
      :series="options.series"
      :style="customStyle"
    >
    </apexchart>
    <div class="info">
      <span>
        <label class="label">
{{ legendTitle }} :
</label>
        <label class="value">
          {{ legendValue }}
        </label>
      </span>
    </div>
  </div>
</template>

<script>
import { convertToK } from '@/utils/helper-function';

export const colors = [
  '#F7517F',
  '#28EFC9',
  '#8EBDFE',
  '#F1A4E0',
  '#fdfcac',
  '#fdfcac',
  '#FFD800',
  '#FFFF53',
  '#FDFCAC',
  '#FFFFFF',
  '#FF0080',
  '#F54AA0',
  '#FF96CB',
  '#FF0A0A',
  '#FF4A4A',
];

export const getColor = (index) => {
  if (index >= colors.length || index < 0) index = 0;
  return colors[index];
};
/**
 * This is just for demo purpose
 * This code lot of generalization and work for real api integration
 *
 *
 *
 */

export default {
  props: {
    customStyle: { type: Object, default: () => {} },
    label: { type: Array, default: () => [] },
    series: { type: Array, default: () => [] },
    chartCenterData: { default: '' },
    legendTitle: { type: String, default: '' },
    legendValue: { default: '' },
    colors: { type: Array, default: () => [] },
  },
  data() {
    return {
      options: {
        series: this.series,
        chart: {
          type: 'radialBar',
          height: '100%',
          width: '100%',
        },
        colors: this.colors,
        tooltip: {
          enabled: true,
          theme: 'dark',
          fillSeriesColor: false,
          style: {
            fontSize: '12px',
            fontFamily: undefined,
            background: 'black',
          },
          y: {
            formatter: (val) => {
              return val + '%';
            },
          },
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                show: false,
                fontSize: '22px',
              },
              value: {
                fontSize: '20px',
                color: 'white',
                formatter: (x) => {
                  return x + '%';
                },
              },
              total: {
                show: true,
                label: 'Total',
                formatter: () => {
                  // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                  return convertToK(this.chartCenterData);
                },
              },
            },
            track: {
              enabled: false,
              background: 'transparent',
            },
          },
        },
        labels: this.label,
      },
    };
  },
  watch: {
    series: {
      deep: true,
      handler(_newValues) {
        this.options.series = _newValues;
      },
    },
    label: {
      deep: true,
      handler(_newValues) {
        this.options = { ...this.options, labels: _newValues };
      },
    },
  },
  methods: {
    convertToK,
  },
};
</script>

<style lang="scss">
.label,
.value {
  padding-right: 1rem;
}

.label {
  color: #909090;
  font-size: 1rem;
}

.value {
  font-size: 2rem;
  color: $font-primary;
}

.chart-radial-box {
  display: flex;
  flex-direction: column;
}
</style>
